export default "__VITE_ASSET__7wco0Hmo__"